import { render, staticRenderFns } from "./PersonnelRecordDetailsTabContact.vue?vue&type=template&id=fe18e094"
import script from "./PersonnelRecordDetailsTabContact.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports